import React, { useState } from 'react'
import SideModal from '../SideModal'
import LanguageAndCurrencyContent from '../../../LanguageAndCurrency/LanguageAndCurrencyContent'
import styles from './style.module.scss'
import { useAppSetting } from '@/components/appStore'
import { localCache } from '@hotcoin/utils/dist/utils/cache'

const LanguageAndCurrencySection: React.FC = () => {
  const currencyCode = useAppSetting('currencyCode')

  let localeName = ''
  if (typeof window !== 'undefined') {
    localeName = localCache.getCache('curLocale')?.name ?? ''
  }

  const [isLanguageAndCurrencyVisible, setIsLanguageAndCurrencyVisible] = useState(false)

  return (
    <>
      <div className={styles.languageAndCurrency} onClick={() => setIsLanguageAndCurrencyVisible(true)}>
        <i className={styles.icon}></i>
        <span className={styles.label}>
          {localeName}/{currencyCode}
        </span>
      </div>

      <SideModal isOpen={isLanguageAndCurrencyVisible} onClose={() => setIsLanguageAndCurrencyVisible(false)}>
        <div className={styles.languageAndCurrencySideModalH}>
          <i onClick={() => setIsLanguageAndCurrencyVisible(false)} className="iconfont iconyoujiantou"></i>
        </div>
        <LanguageAndCurrencyContent onClose={() => setIsLanguageAndCurrencyVisible(false)} showCloseButton={false} />
      </SideModal>
    </>
  )
}

export default LanguageAndCurrencySection
